import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { aiKeys } from '@core/react-query/features/ai/aiKeys'

export const useUploadFile = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['uploadFile']
  >,
) => {
  return useMutation({
    ...aiKeys.uploadFile,
    // We don't retry mutations since they're not idempotent
    // We can allow retries if we implement idempotency keys and idempotency checking on the back-end
    retry: 0,
    ...options,
  })
}
